import { useEffect, useRef, useState } from 'react';
import { Folder, MoreHorizontal, Trash2 } from 'lucide-react';

const COLORS = {
  emerald: { bg: 'bg-emerald-500/10', text: 'text-emerald-400' },
  purple:  { bg: 'bg-brand-500/10',  text: 'text-brand-400' },
  red:     { bg: 'bg-red-500/10',     text: 'text-red-400' },
  blue:    { bg: 'bg-blue-500/10',    text: 'text-blue-400' },
  amber:   { bg: 'bg-amber-500/10',   text: 'text-amber-400' },
  pink:    { bg: 'bg-pink-500/10',    text: 'text-pink-400' },
  zinc:    { bg: 'bg-surface-2',       text: 'text-ink-2' },
};

export default function FolderCard({ folder, onClick, onDelete }) {
  const c = COLORS[folder.cor] || COLORS.zinc;
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;
    const onDocClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [menuOpen]);

  const handleDelete = (e) => {
    e.stopPropagation();
    setMenuOpen(false);
    const total = Number(folder.total_campanhas || 0);
    const aviso = total > 0
      ? `Excluir a pasta "${folder.nome}"? As ${total} campanha(s) dentro dela ficarão sem pasta. Continuar?`
      : `Excluir a pasta "${folder.nome}"?`;
    if (!confirm(aviso)) return;
    onDelete?.(folder);
  };

  return (
    <div
      onClick={() => onClick?.(folder)}
      className="group rounded-xl bg-surface-1 border border-white/[0.06] hover:border-white/[0.08] p-4 cursor-pointer transition-all hover:-translate-y-0.5"
    >
      <div className="flex items-start justify-between mb-3">
        <div className={`w-10 h-10 rounded-lg grid place-items-center ${c.bg}`}>
          <Folder className={`w-5 h-5 ${c.text}`} strokeWidth={1.8} />
        </div>
        <div className="relative" ref={menuRef}>
          <button
            className="opacity-0 group-hover:opacity-100 p-1 rounded hover:bg-surface-2"
            onClick={(e) => { e.stopPropagation(); setMenuOpen((o) => !o); }}
          >
            <MoreHorizontal className="w-4 h-4 text-ink-4" />
          </button>
          {menuOpen && (
            <div
              className="absolute right-0 top-full mt-1 z-20 min-w-[160px] rounded-lg bg-surface-1 border border-white/[0.06] shadow-xl py-1"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={handleDelete}
                className="w-full flex items-center gap-2 px-3 py-2 text-sm text-red-400 hover:bg-red-500/10"
              >
                <Trash2 className="w-3.5 h-3.5" /> Excluir
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="text-ink-1 font-semibold text-sm">{folder.nome}</div>
      <div className="text-xs text-ink-4 mt-1">{folder.total_campanhas || 0} campanhas</div>
    </div>
  );
}
